import Toast from 'react-native-toast-message'

type ToastType = 'success' | 'error' | 'info'

type ShowToastParams = {
  type: ToastType
  title: string
  message?: string
  visibilityTime?: number
}

export function showToast({
  type,
  title,
  message,
  visibilityTime = 2500,
}: ShowToastParams) {
  Toast.show({
    type,
    text1: title,
    text2: message,
    position: 'top',
    visibilityTime,
    autoHide: true,
    topOffset: 16,
  })
}

export function showSuccessToast(title: string, message?: string) {
  showToast({ type: 'success', title, message })
}

export function showErrorToast(title: string, message?: string) {
  showToast({ type: 'error', title, message, visibilityTime: 3500 })
}

export function showInfoToast(title: string, message?: string) {
  showToast({ type: 'info', title, message })
}

